export default __webpack_public_path__ + "static/matcapimg-756b61399556b60465bd0c15f37b374e.jpg";